export default "__VITE_ASSET__Dpx5yZXn__"